/*! accordions */

$(document).ready(function () {

    // Accordions
    var accordions = '.accordion-container .accordion-title';
    $(accordions).click(function (e) {
        e.preventDefault();
        var $target = $(e.target);
        var isVisible = $target.hasClass('active');
        var $container = $target.closest('.accordion-container');
        $container.find('.accordion-title').removeClass('active');
        $container.find('.accordion-content').removeClass('active').attr('aria-hidden', 'true');;
        if (isVisible != true) {
            $target.addClass('active');
            $target.next('.accordion-content').addClass('active').attr('aria-hidden', 'false');;
            PutElementIntoView($target);
        }
    });

});

